export const toolbarCalendarModule = {
  name: 'Toolbar Calendar',
};
